import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "./auth/AdminAuthProvider";
import AppAdmin from "./AppAdmin";
import AdminSignIn from "./pages/AdminSignIn";

export default function AdminGate() {
  const { session, loading } = useAdminAuth();
  const location = useLocation();

  // ✅ "Nothing should appear" until we know auth state
  if (loading) return null;

  // Not logged in -> show sign-in page
  if (!session) return <AdminSignIn />; 

  // Logged in but hits /admin (no subpath) -> send to dashboard
  if (location.pathname === "/admin" || location.pathname === "/admin/") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Logged in -> render admin app (layout, routes, etc.)
  return <AppAdmin />;
}